import React, { memo, useCallback } from 'react';
import Humanize from 'humanize-plus';
import COLORS from 'constants/colors';

import { Text } from '@cuemath/web-comps';

import { formatDurationMs, getInvalidReasonLabel } from '../../helpers';
import { VERDICT_STATES, VERDICT_DISPLAY } from '../../constants';
import {
  RowContainer,
  EventIndexCell,
  EventVerdictCell,
  ChunkCountCell,
  DurationCell,
  ButtonText,
} from './event-summary-row-styled';
import { TextButton } from '../../av-review-detail-styled';

const EventSummaryRow = ({ event, index, onReReview, isReviewSubmitted }) => {
  const chunkCount = event.event_data?.length || 0;
  const verdictConfig =
    VERDICT_DISPLAY[event.is_valid ? VERDICT_STATES.VALID : VERDICT_STATES.INVALID];
  const handleClick = useCallback(() => onReReview(index), [onReReview, index]);

  return (
    <RowContainer
      bg={verdictConfig.bgColor}
      flexDirection="row"
      alignItems="center"
      gap={12}
      gutter={16}
      onClick={handleClick}
    >
      <EventIndexCell>
        <Text variant="cta2" color={COLORS.COLA}>
          Event {index + 1}
        </Text>
      </EventIndexCell>
      <EventVerdictCell>
        <Text variant="body3" color={verdictConfig.color}>
          {verdictConfig.icon} {verdictConfig.label}
        </Text>
        {event.is_valid === false && event.invalid_reason && (
          <Text variant="body3" color={COLORS.BLACK_T_60}>
            {'\u2022 '}
            {getInvalidReasonLabel(event.event_type, event.invalid_reason)}
          </Text>
        )}
      </EventVerdictCell>
      <ChunkCountCell>
        <Text variant="body3" color={COLORS.BLACK_T_60}>
          {chunkCount} {Humanize.pluralize(chunkCount, 'Chunk')}
        </Text>
      </ChunkCountCell>
      <DurationCell>
        <Text variant="body3" color={COLORS.BLACK_T_60}>
          {event.total_duration != null ? formatDurationMs(event.total_duration) : '-'}
        </Text>
      </DurationCell>
      <TextButton>
        <ButtonText variant="cta2" color={COLORS.BLACK}>
          {isReviewSubmitted ? 'View' : 'Re-review'} &rarr;
        </ButtonText>
      </TextButton>
    </RowContainer>
  );
};

export default memo(EventSummaryRow);
